/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { NavigationItemLink } from "@/src/types/Navigation.ts";
import { Stack, SxProps, Theme } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Link } from "react-router";
import { mergeSx } from "@/src/utils/mergeSx.ts";
import { useHeader } from "@/src/components/Header/HeaderProvider.tsx";
import { navCategoryAccordionStyle } from "@/src/components/Header/NavCategoryAccordion/navCategoryAccordionStyle.ts";

export type NavCategoryAccordionProps = {
  items: NavigationItemLink[];
  open?: boolean;
};
export default function NavCategoryAccordion({ items, open }: NavCategoryAccordionProps) {
  const { setMobileNavActive } = useHeader();

  return (
    <Stack sx={mergeSx(navCategoryAccordionStyle.navCategoryAccordion, open && navCategoryAccordionStyle.open)} useFlexGap>
      {items.map((item) => {
        return (
          <Typography
            key={item.label + item.type}
            component={Link}
            sx={navCategoryAccordionStyle.link}
            to={item.to}
            onClick={() => setMobileNavActive?.(false)}
            aria-current={item.active ? "page" : undefined}
          >
            {item.label}
          </Typography>
        );
      })}
    </Stack>
  );
}
